import { Controller } from "@hotwired/stimulus"

const DEFAULT_ACTIVE = ["text-indigo-600", "border-indigo-600"]
const DEFAULT_INACTIVE = ["text-gray-500", "border-transparent", "hover:text-gray-700", "hover:border-gray-300"]

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    active: { type: Number, default: 0 },
    activeClasses: { type: String, default: "" },
    inactiveClasses: { type: String, default: "" }
  }

  connect() {
    this.activeClassList = this.activeClassesValue ? this.activeClassesValue.split(" ") : DEFAULT_ACTIVE
    this.inactiveClassList = this.inactiveClassesValue ? this.inactiveClassesValue.split(" ") : DEFAULT_INACTIVE
    this.showTab(this.activeValue)
  }

  switch(event) {
    const index = parseInt(event.currentTarget.dataset.tabIndex)
    this.showTab(index)
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add(...this.activeClassList)
        tab.classList.remove(...this.inactiveClassList)
      } else {
        tab.classList.remove(...this.activeClassList)
        tab.classList.add(...this.inactiveClassList)
      }
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })

    this.activeValue = index
  }
}
